import { lazy } from 'react';

export const PlayerUpdateGamanzaStatusForm = lazy(
  () => import('./PlayerUpdateGamanzaStatusForm'),
);
